import React from "react";

const Footer = () => {
  return (
    <div className="d-flex justify-content-center align-items-center m-auto footer">
      <p>&copy; 2021 Watchwood - By Michelle Naim</p>
    </div>
  );
};

export default Footer;
